import { map } from 'lodash/fp';
import { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { ContentWrapper, StateContainer } from './styles';
import { ModalComponentProps } from '../../../../../../components/embedded-widget/types';
import { STATE_OPTIONS } from '../../../../../../models/customer/constants';
import { StyledHeading, StyledJourneyButton } from '../styles';

const StateSelector = ({ setIsModalOpen }: ModalComponentProps) => {
  const { setFieldValue } = useFormikContext();

  const setStateHandler = useCallback(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'state' implicitly has an 'any' type.
    (state) => {
      setFieldValue('state', state);
      setIsModalOpen(false);
    },
    [setFieldValue, setIsModalOpen],
  );

  return (
    <ContentWrapper>
      <StyledHeading looksLike="h5">Please select your state.</StyledHeading>
      <StateContainer>
        {map(
          (state) => (
            <StyledJourneyButton key={state.value} onClick={() => setStateHandler(state.value)}>
              {state.text}
            </StyledJourneyButton>
          ),
          STATE_OPTIONS,
        )}
      </StateContainer>
    </ContentWrapper>
  );
};

export default StateSelector;
